import { render } from "./ReservationScreenView.vue?vue&type=template&id=ecafda16&scoped=true"
import script from "./ReservationScreenView.vue?vue&type=script&lang=js"
export * from "./ReservationScreenView.vue?vue&type=script&lang=js"

import "./ReservationScreenView.vue?vue&type=style&index=0&id=ecafda16&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecafda16"]])

export default __exports__